const commentData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20modern%20professional%20headshot%20style&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '15分钟前',
    content: '这个瓜太大了！没想到事情还有这么多内幕，坐等后续发展。这届网友的扒料能力真的越来越强了。',
    likes: '2.3千',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20friendly%20expression%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20modern%20professional%20headshot%20style&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    name: '理性吃瓜人',
    time: '28分钟前',
    content: '建议大家先不要急着站队，等双方都回应了再下结论。理性吃瓜，文明讨论，这才是吃瓜的正确姿势。',
    likes: '1.8千',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20modern%20professional%20headshot%20style&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    name: '娱乐圈小灵通',
    time: '42分钟前',
    content: '据我了解的情况，这个事情背后还有更大的料没爆出来。已经在联系知情人士了，有新消息第一时间来分享！',
    likes: '3.6千',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-accent-100">
            <i className="ri-message-2-line text-accent-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">精彩评论</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">吃瓜群众的精彩发言，看看大家都在聊什么</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentData.map((comment) => (
            <div
              key={comment.name}
              className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 flex flex-col gap-3"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800 truncate">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400 mt-auto">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}